
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesInvites = View.ExtendedLeaguesInvites.extend({
		template: JST.ExtendTippingLeaguesInvitesForAflClubs,
		ui: {
			send_list_invites:    '.js-send-invites',
			share_btn:            '.js-share',
			gmail_btn:            '.js-gmail',
			whatsapp_btn:         '.js-whatsapp',
			modal_container:      '#js-modal-container',
			modal:                '#js-modal',
			modal_content:        '.js-modal-content',
			select:               '.js-modal-select',
			select_all:           '.js-modal-select-all',
			modal_close:          '.js-modal-close',
			modal_submit:         '.js-modal-submit',
			emails_list:          '.js-emails-list',
			emails_message:       '.js-emails-message',
			url_field:            '.js-invite-link',
			copy_link:            '.js-copy-link',
			success_message:      '.js-already-copied'
		}
	});

}(window, APP, Backbone, Marionette, $, _));